/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

import postRoutes from './post'
import formRoutes from './form'
import adminRoutes from './admin'
import companyRoutes from './company'
import newsRoutes from './news'
import eventsRoutes from './events'
import notificationsRoutes from './notifications'
import statisticsRoutes from './statistics'

import PageNotFound from '@/views/UI/PageNotFound'

Vue.use(VueRouter)

const baseRoutes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/UI/Home.vue')
    },
    {
        path: '/403',
        name: 'Page403',
        component: () => import('@/views/UI/Forbidden.vue')
    },
    {
        path: '/404',
        name: 'Page404',
        component: () => import('@/views/UI/PageNotFound.vue')
    },
    {
        path: '/sanctum',
        name: 'LoginSanctum',
        component: () => import('@/views/UI/LoginSanctum.vue')
    },
    {
        path: '/password-reset/:token',
        name: 'PasswordReset',
        component: () => import('@/views/UI/PasswordReset.vue')
    },
    {
        path: '/documentation',
        name: 'Documentation',
        component: () => import('@/views/UI/Docs.vue')
    },
    {
        path: '/profile',
        name: 'MyProfile',
        component: () => import('@/views/UI/MyProfile.vue')
    },
]

const routes = baseRoutes.concat(
    postRoutes,
    formRoutes,
    adminRoutes,
    companyRoutes,
    newsRoutes,
    eventsRoutes,
    notificationsRoutes,
    statisticsRoutes
)

routes.push({ path: '*', name: 'PageNotFound', component: PageNotFound })

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token')
    var passwordResetComponent = 'PasswordReset'
    var loginComponent = 'LoginSanctum'
    var homeComponent = 'Home'

    if (
        to.name !== passwordResetComponent &&
        to.name !== loginComponent &&
        (!token || token.length <= 0)
    )
        next({ name: loginComponent })
    else if (
        (to.name === loginComponent && token) ||
        (to.name === passwordResetComponent && token)
    )
        next({ name: homeComponent })
    else if (to.meta && to.meta.superAdminOnly) {
        const role = JSON.parse(localStorage.getItem('role') || 'null')
        const roleName = role && typeof role === 'object' ? role.name : role
        if (roleName !== 'super-admin') {
            next({ name: 'Page403' })
        } else {
            next()
        }
    }
    else if (to.meta && (to.meta.permission || to.meta.anyPermission)) {
        const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
        const allowed = to.meta.anyPermission
            ? to.meta.anyPermission.some((permission) => permissions.includes(permission))
            : permissions.includes(to.meta.permission)
        if (!allowed) {
            next({ name: 'Page403' })
        } else {
            next()
        }
    }
    else next()
})


export default router
